import { api } from "@/lib/api";

// Chunked upload so large videos never hit proxy body limits. Returns the saved media slot value.
export async function uploadVideoInChunks(file, slot, onProgress) {
  const { data: init } = await api.post("/media/uploads", {
    filename: file.name,
    content_type: file.type,
    size: file.size,
    slot,
  });
  const total = Math.ceil(file.size / init.chunk_size);
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * init.chunk_size, Math.min(file.size, (i + 1) * init.chunk_size));
    await api.put(`/media/uploads/${init.upload_id}/chunks/${i}`, blob, {
      headers: { "Content-Type": "application/octet-stream" },
    });
    onProgress?.(Math.round(((i + 1) / total) * 92));
  }
  const { data } = await api.post(`/media/uploads/${init.upload_id}/complete`);
  onProgress?.(100);
  return data.value;
}
